import TasksTableActions from '@/components/customer-dashboard/TasksTableActions.vue';
import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import type { Task } from '@/types';
import { formatDate } from '@/utils/helpers';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<Task>[] = [
    {
        accessorKey: 'task_title',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.tasks_table_task',
            }),
    },
    {
        accessorKey: 'task_description',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.tasks_table_task_description',
            }),
    },
    {
        accessorKey: 'status_translated',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.tasks_table_status',
            }),
    },
    {
        accessorKey: 'deadline',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.tasks_table_date',
            }),
        cell: ({ row }) => {
            return formatDate(row.original.deadline);
        },
    },
    {
        accessorKey: 'weekdays',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.weekdays',
            }),
    },
    {
        accessorKey: 'task_responsible_names',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.tasks_table_task_responsible_name',
            }),
    },
    {
        accessorKey: 'task_responsible_ids',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.employee.tasks_table_task_responsible_name',
            }),
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(TasksTableActions, {
                task: row.original,
            });
        },
    },
];
